import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=33c12097&scoped=true&"
import script from "./Layers.vue?vue&type=script&lang=js&"
export * from "./Layers.vue?vue&type=script&lang=js&"
import style0 from "./Layers.vue?vue&type=style&index=0&id=33c12097&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c12097",
  null
  
)

export default component.exports